<script>
import JerseySizeChartModal from 'components/views/my/team/elements/JerseySizeChartModal.svelte';
import SocksSizeChartModal from 'components/views/my/team/elements/SocksSizeChartModal.svelte';
// import modal


let jerseys_size_chart_modal_is_active = false;

let socks_size_chart_modal_is_active = false;


</script>


<style>

</style>


<JerseySizeChartModal bind:is_active={jerseys_size_chart_modal_is_active} />
<SocksSizeChartModal bind:is_active={socks_size_chart_modal_is_active} />


<div class="tabs is-toggle" id="">

	<ul>

		<li>
			<a on:click={() => jerseys_size_chart_modal_is_active = true}>
				Jerseys Size Chart
			</a>
		</li>

		<li>
			<a on:click={() => socks_size_chart_modal_is_active = true}>
				Socks Size Chart
			</a>
		</li>

	</ul>

</div>



